import { render, staticRenderFns } from "./shortcuts.vue?vue&type=template&id=c378226a&scoped=true&"
import script from "./shortcuts.vue?vue&type=script&lang=js&"
export * from "./shortcuts.vue?vue&type=script&lang=js&"
import style0 from "./shortcuts.vue?vue&type=style&index=0&id=c378226a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c378226a",
  null
  
)

export default component.exports